import clsx from '../utils/clsx';
import styles from '../styles/Battlefield.module.css';
import displayStyles from '../styles/Display.module.css';

/**
 * The title card over the map: a beat on every cut, held while the
 * curtain is down.
 *
 * Absolute inside `.stage`, never in flow. `held` is the curtain: the card
 * is opaque and the map behind it is hidden from the viewer - the panel
 * does the hiding, since it owns the SVG; this only says so. A GM never
 * sees it held (they see the map and a badge), so `held` is already the
 * viewer's answer. Reduced motion drops the fade and keeps the words,
 * the impacts' precedent (v8.339.0).
 */
export default function StageTitleCard({ card, held = false, display = false }) {
  if (!card) return null;
  return (
    <div
      // On the display, the card is in its type: the hololith's light, not the classic gold (plan map-display, I).
      className={clsx(
        styles.titleCard,
        held ? styles.titleCardHeld : styles.titleCardBeat,
        display && displayStyles.titleCardDisplay,
      )}
      data-renderer={display ? 'display' : undefined}
      data-testid={held ? 'stage-card-held' : 'stage-card'}
      role="status"
      aria-live="polite"
    >
      <div className={styles.titleCardName}>{card.name}</div>
      {/* On the display, a rule draws out under the name (Z3, the scenes page). */}
      {display && <div className={displayStyles.titleCardRule} data-testid="stage-card-rule" />}
      {card.narration && <div className={styles.titleCardLine}>{card.narration}</div>}
      {held && <div className={styles.titleCardHint}>The curtain is down.</div>}
    </div>
  );
}
